import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import PlayersList from './components/Players/PlayersList';
import TeamsList from './components/Teams/TeamsList';
import TeamDetail from './components/Teams/TeamDetail';
import TeamStatistics from './components/Teams/TeamStatistics';
import CalendarView from './components/Calendar/CalendarView';
import EventsList from './components/Events/EventsList';
import EventDetail from './components/Events/EventDetail';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import RegisterInvitation from './components/Auth/RegisterInvitation';
import AdminPanel from './components/Admin/AdminPanel';
import Profile from './components/Profile/Profile';
import './styles/theme.css';
import './styles/material.css';
import './styles/global.css';
import './styles/buttons.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/inscription/:token" element={<RegisterInvitation />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/accueil" />} />
            <Route path="accueil" element={<Dashboard />} />
            <Route path="membres" element={<PlayersList />} />
            <Route path="equipes" element={<TeamsList />} />
            <Route path="equipes/:teamId" element={<TeamDetail />} />
            <Route path="equipes/:teamId/statistiques" element={<TeamStatistics />} />
            <Route path="calendrier" element={<CalendarView />} />
            <Route path="events" element={<EventsList />} />
            <Route path="events/:id" element={<EventDetail />} />
            <Route path="admin" element={<AdminPanel />} />
            <Route path="profil" element={<Profile />} />
            {/* Redirections pour les anciennes URLs */}
            <Route path="dashboard" element={<Navigate to="/accueil" replace />} />
            <Route path="players" element={<Navigate to="/membres" replace />} />
            <Route path="teams" element={<Navigate to="/equipes" replace />} />
            <Route path="jeux" element={<Navigate to="/admin" replace />} />
            <Route path="games" element={<Navigate to="/admin" replace />} />
            <Route path="calendar" element={<Navigate to="/calendrier" replace />} />
            <Route path="profile" element={<Navigate to="/profil" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
